import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { HttpRequestService } from '@core/http/http-request.service';

interface ApiResponse<T> {
  data: T;
  message: string;
}

export interface CatalogOption {
  id: number;
  name: string;
  alias?: string;
  country_id?: number;
  department_id?: number;
  dane_code?: string;
}

@Injectable({ providedIn: 'root' })
export class PersonasCatalogsService {
  private readonly http = inject(HttpRequestService);

  getDocumentTypes(): Observable<CatalogOption[]> {
    return this.fetchCatalog('/catalogs/document-types', 'No pudimos cargar los tipos de documento.');
  }

  getCountries(): Observable<CatalogOption[]> {
    return this.fetchCatalog('/catalogs/countries', 'No pudimos cargar los países.');
  }

  getDepartments(countryId?: number): Observable<CatalogOption[]> {
    const suffix = countryId ? `?country_id=${countryId}` : '';
    return this.fetchCatalog(`/catalogs/departments${suffix}`, 'No pudimos cargar los departamentos.');
  }

  getCities(departmentId?: number): Observable<CatalogOption[]> {
    const suffix = departmentId ? `?department_id=${departmentId}` : '';
    return this.fetchCatalog(`/catalogs/cities${suffix}`, 'No pudimos cargar las ciudades.');
  }

  getGenders(): Observable<CatalogOption[]> {
    return this.fetchCatalog('/catalogs/genders', 'No pudimos cargar los géneros.');
  }

  getMaritalStatuses(): Observable<CatalogOption[]> {
    return this.fetchCatalog('/catalogs/marital-statuses', 'No pudimos cargar los estados civiles.');
  }

  getHousingTypes(): Observable<CatalogOption[]> {
    return this.fetchCatalog('/catalogs/housing-types', 'No pudimos cargar los tipos de vivienda.');
  }

  private fetchCatalog(endpoint: string, fallbackMessage: string): Observable<CatalogOption[]> {
    return this.http.get<ApiResponse<CatalogOption[]>>(endpoint).pipe(
      map((response) => response.data),
      catchError((error) => this.handleApiError(error, fallbackMessage))
    );
  }

  private handleApiError(error: any, fallbackMessage: string) {
    const message = error?.error?.message || fallbackMessage;
    return throwError(() => new Error(message));
  }
}
